<ul id="language_selector_container" class="language-menu">
  <li class="dropdown dropdown-user">
    <button
      type="button"
      class="dropdown-toggle text-uppercase hide-default-toggler-icon"
      data-bs-toggle="dropdown"
      aria-haspopup="true"
      aria-expanded="false"
    >
      {{
        getLanguageCodeTranslation(eregistrationsTranslationService.language)
      }}
      <i class="fal fa-angle-down"></i>
    </button>
    <ul class="dropdown-menu dropdown-menu-end">
      <li
        class="dropdown-item"
        *ngFor="let lang of eregistrationsTranslationService.languages$ | async"
      >
        <a
          class="text-uppercase dropdown-item-link"
          (click)="eregistrationsTranslationService.updateLanguage(lang.code)"
          >{{ getLanguageCodeTranslation(lang.code) }}</a
        >
      </li>
    </ul>
  </li>
</ul>
